__turbopack_context__.v({
  "specifications-table": "specifications-table-component-module-scss-module__v6OfeW__specifications-table",
  "specifications-table--collapsed": "specifications-table-component-module-scss-module__v6OfeW__specifications-table--collapsed",
  "specifications-table--first": "specifications-table-component-module-scss-module__v6OfeW__specifications-table--first",
  "specifications-table__cell": "specifications-table-component-module-scss-module__v6OfeW__specifications-table__cell",
  "specifications-table__cell--first": "specifications-table-component-module-scss-module__v6OfeW__specifications-table__cell--first",
  "specifications-table__row": "specifications-table-component-module-scss-module__v6OfeW__specifications-table__row",
});
